import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useCognito } from "../utils/useCognito";

export default function Logout() {
  const { logout } = useCognito();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    // Optionally show a message for a moment, then redirect
    setTimeout(() => {
      navigate("/");
    }, 1200);
  }, [logout, navigate]);

  return (
    <Flex minH="100vh" align="center" justify="center" direction="column">
      <Spinner size="lg" mb={4} />
      <Text fontSize="lg" color="gray.600">Logging out...</Text>
    </Flex>
  );
}
